export var delay = function (timeout) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(void 0);
        }, timeout);
    });
};
